<template>
    <div
        class="container mt-4"
        :class="{
            'on-trial': user.on_trial,
        }"
    >
        <div
            v-if="user.name"
            class="overflow-hidden d-print-none"
        >
            <p class="float-sm-end text-sm-end">
                {{ $t('lesson.purchasedBy') }}: {{ user.name }}
                <br />
                {{ $t('lesson.forUseAt') }}: {{ user.organisation_name }}
            </p>

            <p v-if="series.id">
                {{ seriesTitle }} - {{ $t('lesson.lesson') }} #{{ lesson.sequence_number }}
            </p>
        </div>

        <div
            v-if="user.on_trial"
            class="alert alert-warning text-center d-print-none"
            role="alert"
        >
            {{ $t('forDemoPurposesOnlyUserIsOnFreeTrial') }}
        </div>

        <div
            v-if="(lesson.is_sample && ! isSignedUrl)"
            class="alert alert-secondary text-center d-print-none"
            role="alert"
        >
            {{ $t('lesson.sampleLesson') }}
        </div>

        <div
            v-else-if="lesson.sequence_number"
            class="alert alert-secondary d-print-none text-center"
            role="alert"
        >
            <a
                :href="series.first_lesson_url"
                target="_blank"
            >
                <font-awesome-icon icon="fa-solid fa-book-open" />
                {{ $t('lesson.seriesIntroductionRequest') }}
            </a>
        </div>

        <lesson-header
            :lesson-id="lessonId"
            type="header"
            :language-id="mutableLanguageId"
        />

        <div class="columns-2">
            <div
                v-if="series.id"
                class="card mb-4 d-print-none"
            >
                <div class="card-body">
                    <div class="form-group">
                        <label for="language_id">
                            {{ $t('lesson.lessonLanguage') }}
                        </label>

                        <form-select
                            v-model="mutableLanguageId"
                            name="language_id"
                            :endpoint="`/subscriber/api/series/${series.id}/languages-options`"
                        />
                    </div>

                    <a
                        class="btn btn-success w-100 mt-3"
                        href="#"
                        target="_blank"
                        role="button"
                        @click.prevent="printLesson"
                    >
                        <font-awesome-icon icon="fa-solid fa-print" class="me-1" />
                        {{ $t('lesson.printLesson') }}
                    </a>
                </div>
            </div>

            <series-outline
                v-if="series.id"
                :series-id="series.id"
                :language-id="mutableLanguageId"
                :lesson-id="lessonId"
                class="d-print-none"
            />

            <components-list
                v-if="series.id"
                :lesson-id="lessonId"
                :language-id="mutableLanguageId"
                :series-id="series.id"
            />
        </div>

        <media-list
            v-if="lesson.sequence_number"
            :lesson-id="lessonId"
            :language-id="mutableLanguageId"
        />

    </div>
</template>

<script>
import ComponentsList from "../../partials/subscriber/ComponentsList.vue";
import FormSelect from "../../form-components/FormSelect.vue";
import axios from "axios";
import LessonHeader from "../../partials/subscriber/LessonHeader.vue";
import SeriesOutline from "../../partials/subscriber/SeriesOutline.vue";
import MediaList from "../../partials/subscriber/MediaList.vue";
import { useSeoMeta } from "@unhead/vue";

export default {
    name: "Lesson",

    components: {
        MediaList,
        SeriesOutline,
        LessonHeader,
        FormSelect,
        ComponentsList,
    },

    data() {
        return {
            lessonId: Number(this.$route.params.id),
            mutableLanguageId: Number(this.$route.query.language_id),
            series: {},
            lesson: {},
            user: {},
        };
    },

    watch: {
        mutableLanguageId: {
          handler(newValue) {
            axios({
              method: 'get',
              url: `/subscriber/api/languages/${newValue || this.$app.translationEnglishId}/`,
            })
            .then((response) => {
              this.$i18n.locale = response.data.code.toLowerCase();
            });
          },

          immediate: true,
        },
    },

    computed: {
        hasTranslatedTitle() {
            return (this.series.translations_parsed && this.series.translations_parsed[this.mutableLanguageId]);
        },

        seriesTitle: function() {
            return (this.hasTranslatedTitle ? this.series.translations_parsed[this.mutableLanguageId] : this.series.title);
        },

        pageTitle: function() {
          return (this.seriesTitle ? `${this.$app.appName} - ${this.seriesTitle}` : `${this.$app.appName} - Lesson loading...`);
        },

        isSignedUrl() {
            return (this.$route.query.expires && this.$route.query.signature);
        },
    },

    mounted() {
        this.getLessonSeries();
    },

    methods: {
        getLessonSeries() {
            axios({
                method: 'get',
                url: `/subscriber/api/lessons/${this.lessonId}/?user_id=${this.$route.query.user_id}`,
            })
            .then((response) => {
                this.lesson = response.data.lesson;
                this.series = response.data.series;
                this.user = response.data.user;

                useSeoMeta({
                  title: this.pageTitle,
                  ogTitle: this.pageTitle,
                })
            });
        },

        printLesson() {
            this.$window.print();
        },
    },
};
</script>
